import { gql } from '@apollo/client'

export const MY_PGA_HOPE_GRADUATE_CARDS = gql`
  query MyPgaHopeGraduateCards {
    currentUser {
      representatives {
        relationshipType
        student {
          id
          firstName
          lastName
          pgaHopeGraduateCards {
            id
            serviceBranch
            sectionName
            graduationYear
            issuedAt
          }
        }
      }
    }
  }
`
